import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { masterRecordsSlice } from "@/slice/masterRecordsSlice"
import { RootState } from "@/store"
import { gqlClient } from "@/util/graphql"
import { Alert, AlertTitle, Button, CircularProgress } from "@mui/material"
import { BiCheckCircle, BiTrash } from "react-icons/bi"

export const TemporaryAlert = (props: { tableName: string; onClickFinalize: () => void; isFinalizing: boolean }) => {
	const { tableName } = props

	const dispatch = useDispatch()

	const [isCancelling, setIsCancelling] = React.useState<boolean>(false)

	const hasTemporary = useSelector((state: RootState) => {
		const records = state.masterRecords.data[tableName]
		if (records) {
			return !!records.find((r) => r.stage == "temporary")
		} else {
			return false
		}
	})

	const onClickReject = React.useCallback(() => {
		setIsCancelling(true)
		gqlClient()
			.rejectMasterTable({ tableName })
			.then(({ rejectMasterTable: { recordIds } }) => {
				setIsCancelling(false)
				dispatch(masterRecordsSlice.actions.deleteRecords({ tableName, recordIds }))
			})
	}, [dispatch, tableName, props])

	return hasTemporary ? (
		<Alert
			severity="warning"
			sx={{
				width: "100vw",
				position: "fixed",
				bottom: 0,
				left: 0,
				zIndex: "appBar",
				borderRadius: 0,
			}}
		>
			<AlertTitle>新しく追加された行があります</AlertTitle>
			新しく追加された行は、確定するまで反映されません。
			<Button
				color="inherit"
				startIcon={<BiCheckCircle />}
				onClick={props.onClickFinalize}
				disabled={props.isFinalizing || isCancelling}
			>
				追加された行を全て確定
			</Button>
			<Button
				color="inherit"
				startIcon={<BiTrash />}
				onClick={onClickReject}
				disabled={props.isFinalizing || isCancelling}
			>
				追加された行を全て削除
			</Button>
			{props.isFinalizing || isCancelling ? <CircularProgress size={20} style={{ marginLeft: "0.5em" }} /> : <></>}
		</Alert>
	) : (
		<></>
	)
}
